import React from "react";
import { Image, Tooltip } from "@chakra-ui/react";
import bullhornBull from "../../assets/img/bullhorn-bull.png";

// ImportedInvited flags a triage row whose candidate is a
// candidate_profile_imports record (an external candidate who hasn't signed up
// yet). For this first version those imports are all Bullhorn-sourced, so the
// Bullhorn bull mark alone tells the story — no label. The Moblyze-user
// counterpart is MoblyzeUserLogo.
//
// Pass `isImported` (typically `candidate.isExternal`) so callers can
// short-circuit the render without a wrapping ternary.
function ImportedInvited({ isImported, ...props }) {
  return isImported && (
    <Tooltip label="Sourced from Bullhorn — not on Moblyze yet" hasArrow>
      <Image
        src={bullhornBull}
        alt="Bullhorn"
        boxSize="20px"
        objectFit="contain"
        data-testid="imported-invited-pill"
        {...props}
      />
    </Tooltip>
  );
}

export default ImportedInvited;
